import dayjs from "dayjs";

// constants
import { convertTimeToLocation } from "../common/constant/constant";

import { useDispatch } from "react-redux";
// store
import { fetchUnreadCount } from "../../reducer/slices/notifications/unread-count";

// api
import { ENDPOINTS } from "../../js/api/_config";
import axios from "axios";

// hooks
import { useEffect, useRef } from "react";

const ChatList = ({ trialInfo, latestmessage }) => {
  // get initials
  const loggedRef = useRef(false);
  const dispatch = useDispatch();
  const getInitials = (name) => {
    if (name) {
      return name
        .trim() // Remove leading and trailing whitespace
        .replace(/\s+/g, " ") // Replace multiple spaces with a single space
        .split(" ") // Split into words
        .filter(Boolean) // Remove empty strings
        .slice(0, 2) // Take the first two words
        .map((word) => word[0].toUpperCase()) // Take first letter and capitalize
        .join(""); // Join initials
    }
    return "";
  };

   const formatTime = (timeString) => {
    const date = dayjs(timeString);
    if (!date.isValid()) return "";

    const isCurrentYear = date.year() === dayjs().year();

    return isCurrentYear
      ? date.format("MM[/]DD [at] hh:mm A")
      : date.format("YYYY[/]MM[/]DD [at] hh:mm A");
  };

  const truncate = (text, limit) => {
    if (text) {
      return text.length > limit ? text.substring(0, limit) + "..." : text;
    }
  };

  const updateReadCon = async (trialInfo) => {
    await axios
      .get(
        `${ENDPOINTS.CONVERSATION.GET_UPDATED_CONVERSATION}?patientTrialJuncId=${trialInfo.patientTrialJuncID}&read=true`
      )
      .then(() => {
        dispatch(fetchUnreadCount());
      });
  };

  useEffect(() => {
    if (!loggedRef.current && trialInfo) {
      updateReadCon(trialInfo);
      console.log("trialInfo.patientTrialJuncID", trialInfo);
      loggedRef.current = true;
    }
  }, [trialInfo]);

  // get initials Ends -------------------------
  return (
    <div className="bg-white left-list-conversation w-[390px] h-full testing">
      {/* Search Box */}
      <div className="p-4">
        <div className="flex items-center border rounded-lg p-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5 text-gray-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.35 4.35a7.5 7.5 0 0012.3 12.3z"
            />
          </svg>
          <input
            type="text"
            placeholder="Search"
            className="w-full outline-none ml-2 text-sm"
          />
        </div>
      </div>

      {/* Chat List */}
      <div className="grid">
        <div className="flex flex-col justify-between bg-white">
          <div className="cursor-pointer relative flex pl-4 items-center justify-between h-[82px] bg-white hover:bg-[#F1F1FD] allChatList pr-5 active">
            <p className="mr-1">
              <span className="recruiter-intials">
                {getInitials(trialInfo?.patientName)}
              </span>
            </p>
            <div
              className="h-full w-full flex items-left justify-center flex-col text-left"
              style={{ color: "#667783" }}
            >
              <p className="big-text justify-between">
                {truncate(trialInfo?.patientName, 13)}
                <span className="text-xs mt-1">
                  {formatTime(
                    convertTimeToLocation(latestmessage?.createdAt)
                  )}
                </span>
              </p>
              <p className="text-xs text-gray-500 block truncate w-3/4">
                {truncate(latestmessage?.msgContent, 35)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatList;
